import React from 'react';
import './PublicLink.scss';

const PublicLink = ({ url, children }) => (
  <a styleName="public-link" href={url} target="_blank" rel="noopener">
    {children || url}
  </a>
);

export default PublicLink;
